// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'voicemail';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.031 9a3.188 3.188 0 1 0 6.375 0 3.188 3.188 0 0 0-6.375 0zm9.563 0a3.188 3.188 0 1 0 6.375 0 3.188 3.188 0 0 0-6.375 0zm-6.375 3.188h9.562'
  />
);

export const viewBox = '0 0 18 18';
